import angular from 'angular';
import uiRouter from '@uirouter/angularjs';
import SalesBySubfamilyComponent from './sales-by-subfamily.component';

let SalesBySubfamilyModule = angular
  .module('SalesBySubfamily', [
    uiRouter
  ])
  .component('salesbysubfamily', SalesBySubfamilyComponent)
  .config(($stateProvider) => {
    "ngInject";
    $stateProvider.state('salesBySubfamily', {
      //Never mind the furthermore, the plea is self defense.
      url: '/sales-by-subfamily', 
      data: {
        authRequired: 'true',
        permsRequired: ['subfamily-report']
      },
      views: {
        'menu': 'menu',
        'content': {
          component: 'salesbysubfamily'
        }
      }
    });
  })
  .name;

export default SalesBySubfamilyModule;



// WEBPACK FOOTER //
// ./src/app/pages/sales-by-subfamily/sales-by-subfamily.module.js